import React from "react";
import "../widgets.scss";
import "../radialgauge.scss";
import wrapWidget from "../WidgetHOC";
import wrapMockedWidget from "../MockedWidgetHOC";

import { lightColor } from "../../../../../helpers/colors";

import { scaleLinear } from "d3-scale";

const LINE_WIDTH = 8;

const LinearGauge = props => {
  let {
    liveSensorValue,
    //resolvedSensorConfig,
    thisWidgetConfig,
    widgetColor,
    widgetSize,
    isMock
  } = props;

  // light color
  let _lightWidgetColor = lightColor(widgetColor);

  let widget_width, widget_height;

  try {
    widget_width = widgetSize.width; 
    widget_height = widgetSize.height;
  } catch (error) {
    console.error(error);
  }

  let vMode = widget_height > widget_width;

  if (isMock){
      vMode = false;
  }

  let { widgetSettings = {} } = thisWidgetConfig;

  let sensorValue = 0;
  //let sensorUnit = "";

  try {
    sensorValue = (liveSensorValue && liveSensorValue.value) || 0;
    sensorValue = parseFloat(sensorValue).toFixed(2);
  } catch (error) {
    console.error(error);
  }

  let max = parseFloat(widgetSettings.max_value) || 100;
  let min = parseFloat(widgetSettings.min_value) || 0;
  let val = parseFloat(sensorValue);

  let frac = (val - min) / (max - min);
  frac = frac > 1 ? 1 : frac;
  frac = frac < 0 ? 0 : frac;

  // Skala
  let PADDING_X = 20;

  let xScale_rel = scaleLinear()
    .domain([min, max])
    .range([0,1])
    .clamp(true);

  let xScale = scaleLinear()
    .domain([min, max])
    .range([PADDING_X, widget_width -  PADDING_X])
    .clamp(true);


  let yScale_rel = scaleLinear()
    .domain([0, 100])
    .range([0, widget_height])
    .clamp(true);

  // val
  let val_abs = xScale(val);

  // Limits
  let { lower_limit, upper_limit } = widgetSettings;
  let lower_limit_rel = 0;
  let upper_limit_rel = 1;
  let isInLowerLimit = false;
  let isInUpperLimit = false;

  if (lower_limit) {
    lower_limit_rel = xScale_rel(lower_limit);
    if (frac < lower_limit_rel) {
      isInLowerLimit = true;
    }
  }
  if (upper_limit) {
    upper_limit_rel = xScale_rel(upper_limit);
    if (frac > upper_limit_rel) {
      isInUpperLimit = true;
    }
  }

  // Dial
  let dialColor = widgetColor;
  let limitCSSClass = "widgetColor";

  if (isInLowerLimit || isInUpperLimit) {
    limitCSSClass = "colorFlashAnim"
    dialColor = "#ff9800"
  }

  let dialTransform = `translate(${val_abs},${yScale_rel(50) + 4 + 15})`;
  let trianglePoints = `-10,15 10,15 0,0`;
  let triangle = <polygon points={trianglePoints} fill={dialColor} />;

  let triangleDial = (
    <line
      x1="0"
      x2="0"
      y1={"2"}
      y2={"-31"}
      stroke={dialColor}
      strokeWidth="1"
    />
  );

  let marker = (
    <g transform={dialTransform} className="tt">
      {triangle} {triangleDial}
    </g>
  );

  // Lines

  let bgLine = (
    <line
      stroke={_lightWidgetColor}
      strokeWidth={LINE_WIDTH}
      x1={PADDING_X - 1}
      x2={widget_width - PADDING_X + 1}
      y1={yScale_rel(50)}
      y2={yScale_rel(50)}
    />
  );

  let fgLine = (
    <line
      stroke={widgetColor}
      strokeWidth={LINE_WIDTH}
      x1={PADDING_X - 1}
      x2={val_abs}
      y1={yScale_rel(50)}
      y2={yScale_rel(50)}
      className="tt"
    />
  );

  //
  // Ticks

  let { show_ticks = true } = widgetSettings;

  let pixelPerTick = 60;
  let nb_ticks = (widget_width - 2 * PADDING_X) / pixelPerTick;
  let xTicks = xScale.ticks(nb_ticks).map(xScale);

  // TODO: use textpath.
  let tickMarks = show_ticks && xTicks.map((xTick, idx) => {
    let even = idx % 2 === 0;
    //let isFirst = idx === 0;
    let isLast = idx === xTicks.length - 1;

    // Make tick color dependent on wether the value has gone poast the tick or not.
    let tickColor = (xTick > val_abs) ? _lightWidgetColor : widgetColor;

    let tickLength = even ? 8 : 4;
    //tickLength += TRACK_W;
    return (
      <g key={`lt${idx}`}>
        <line
          className="radialgauge-widget-tickline"
          x1={xTick + "px"}
          x2={xTick + "px"}
          y1={0}
          y2={-tickLength}
          strokeWidth="2"
          stroke={tickColor}
        />
        { //TODO: the even || isLast makes it always render the last tick label. 
          // this is a workaraound, because ticks doesnt alwasys return the specified nb of ticks.
          // TODO: make this nicer  
         }
        {(even || isLast) && (
          <text
            x={xTick + "px"}
            y={-15}
            dominantBaseline="baseline"
            textRendering="optimizeLegibility"
            fontSize="1em"
            textAnchor="middle"
            fontFamily="Helvetica, sans-serif"
            fill="black"
          >
            {xScale.invert(xTick)}
          </text>
        )}
      </g>
    );
  });

  let tickMarksGroup = (
    <g transform={`translate(0,${yScale_rel(50) - 4})`}>{tickMarks}</g>
  );


  // Limits

  let limitLine1 = lower_limit && <line x1={xScale.range()[0] -1 } x2={xScale(lower_limit) -1} y1="0" y2="0" stroke="#ff9800" strokeWidth="6" className={isInLowerLimit ? limitCSSClass : undefined}/>
  let limitLine2 = upper_limit && <line x1={xScale(upper_limit) +1} x2={xScale.range()[1] +1} y1="0" y2="0" stroke="#ff9800" strokeWidth="6" className={isInUpperLimit ? limitCSSClass : undefined}/>

  let limitLines = <g transform={`translate(0,${yScale_rel(50) + 11})`}>{limitLine1} {limitLine2}</g>
  return (
    <div className="radialgauge-widget">
      {vMode ?
       <div> V MODE </div>
        : 
        <svg
        className="radialgauge-widget-svg"
        //viewBox={`0 0 100 ${widget_height/widget_width*100}`}
        width="100%"
        height="100%"
      >
        <g>
          {tickMarksGroup}
          {bgLine}
          {fgLine}
          {limitLines}
          {marker}
        </g>
      </svg>}
    </div>
  );
};

const MockedLinearGauge = wrapMockedWidget(LinearGauge);
export { MockedLinearGauge };
export default wrapWidget(LinearGauge);
